import EquipmentUtils from 'utils/EquipmentUtils';
import initialStepValidation from 'reducers/work-order/close-step-validation/initialStepValidation';
import outletSqcCheck from 'reducers/work-order/close-step-validation/outletSqcCheck';
import { isSkinnyInstallType, isDisconnectType, isServiceRequestType } from "../../../utils/helper";

export default (state, orderId) => {
    let currentValidation = state.getIn(['workOrderDetails', orderId, 'orderClose', 'details', 'stepValidation']) || initialStepValidation;
    const equipmentDetails = state.getIn(['workOrderDetails', orderId, 'equipmentDetails', 'details']);
    const sqcDetails = state.getIn(['workOrderDetails', orderId, 'sqcResults', 'details']);
    const bypassBecauseOfFailure = state.getIn(['workOrderDetails', orderId, 'sqcResults', 'bypassBecauseOfFailure']);
    const outletsToSqc = EquipmentUtils.getSqcableEquipment(equipmentDetails);

    const workOrderDetails = state.getIn(["workOrderDetails", orderId]);

    const signalLevelErrors = workOrderDetails.getIn([
      "orderClose",
      "details",
      "pmTicketSignalLevelsDetails",
      "errors",
    ]);

    const serviceTypeId = state.getIn([
        'workOrderDetails',
        orderId,
        'schedulingSystemDetails',
        'details',
        'serviceOrderInfoV2',
        'serviceTypeId'
    ]);

    const orderStatus = state.getIn([
        'workOrderDetails',
        orderId,
        'orderClose',
        'details',
        'closeOrderRequest',
        'orderStatus'
    ]);

    currentValidation = currentValidation.setIn([
        'sqc', 'isValid'
    ], true)
        .setIn([
            'sqc', 'message'
        ], null).setIn([
            'sqc', 'isWarning'
        ], false);

    const currentTickets = state.getIn([
        'workOrderDetails',
        orderId,
        'orderClose',
        'details',
        'closeOrderRequest',
        'ticketRequests'
    ]);

    if (orderStatus === 'Canceled') {
        return currentValidation;
    }

    let outletCheckResult = {};

    if (!isSkinnyInstallType(serviceTypeId) && !isDisconnectType(serviceTypeId) && !isServiceRequestType(serviceTypeId)) {
        if (equipmentDetails && outletsToSqc && outletsToSqc.count() > 0 && !sqcDetails && !bypassBecauseOfFailure) {
            return currentValidation.setIn([
                'pmTicket', 'isValid'
            ], false).setIn([
                'sqc', 'message'
            ], 'Modem level check must be run.').setIn([
                'sqc', 'isWarning'
            ], true);
        }

        if (outletsToSqc && !bypassBecauseOfFailure) {
            outletCheckResult = outletSqcCheck(outletsToSqc, sqcDetails, currentValidation);

            if (outletCheckResult.currentValidation) {
                return outletCheckResult.currentValidation;
            }
        }

        if (outletCheckResult && outletCheckResult.totalFailCount > 0) {
            currentValidation = currentValidation.setIn([
                'sqc', 'isWarning'
            ], true).setIn([
                'sqc', 'message'
            ], 'Metrics are failing');
        }
    }

    currentValidation = currentValidation.setIn([
        'pmTicket', 'isValid'
    ], true).setIn([
        'pmTicket', 'message'
    ], null);

    //see if used anywhere else remove
    if (orderStatus === 'NoAccess') {
        outletCheckResult.needsMtOrder = false;
    }

    if (!currentTickets && outletCheckResult.needsMtOrder && !bypassBecauseOfFailure) {
        currentValidation = currentValidation.setIn([
            'pmTicket', 'isValid'
        ], false).setIn([
            'pmTicket', 'message'
        ], 'A pm ticket is needed.').setIn([
            'sqc', 'isWarning'
        ], true).setIn([
            'sqc', 'message'
        ], `SQC is failing, a pm ticket is needed`);
    }

    if (currentTickets) {
        const pmTicket = currentTickets.find((item) => {
            return item.get('workType') === 'Maintenance';
        });

        const pmTicketSignalLevels = pmTicket ? pmTicket.get('pmTicketSignalLevel') : null;

        if (!pmTicket && outletCheckResult.needsMtOrder && !bypassBecauseOfFailure) {
            currentValidation = currentValidation.setIn([
                'pmTicket', 'isValid'
            ], false).setIn([
                'pmTicket', 'message'
            ], 'A pm ticket is needed.').setIn([
                'sqc', 'isWarning'
            ], true).setIn([
                'sqc', 'message'
            ], 'SQC is failing, a pm ticket is needed').setIn([
                'sqc', 'isWarning'
            ], true);
        }

        if (pmTicket && !pmTicket.get('comment')) {
            currentValidation = currentValidation.setIn([
                'pmTicket', 'isValid'
            ], false).setIn([
                'pmTicket', 'message'
            ], 'A comment is required.');
        }

        if (pmTicket && !pmTicketSignalLevels && pmTicket.get('comment')) {
            currentValidation = currentValidation.setIn([
                'pmTicket', 'isValid'
            ], false).setIn([
                'pmTicket', 'message'
            ], 'Signal levels are required.');
        }
        if (pmTicket && pmTicketSignalLevels && pmTicket.get('comment')) {
            const signalLevelForm = {
                tapHigh: pmTicketSignalLevels.tapHigh,
                tapLow: pmTicketSignalLevels.tapLow,
                tapTx: pmTicketSignalLevels.tapTx,
                tapRx: pmTicketSignalLevels.tapRx,
                groundBlockHigh: pmTicketSignalLevels.groundBlockHigh,
                groundBlockLow: pmTicketSignalLevels.groundBlockLow,
                groundBlockTx: pmTicketSignalLevels.groundBlockTx,
                groundBlockRx: pmTicketSignalLevels.groundBlockRx,
                postBerIssue: pmTicketSignalLevels.postBerIssue
            };

            const isValid = !Object.keys(signalLevelForm).some(field => !signalLevelForm[field]);

            if (!signalLevelErrors) {
                currentValidation = currentValidation
                .setIn(["pmTicket", "isValid"], isValid)
                .setIn(
                    ["pmTicket", "message"],
                    isValid ? "" : "Signal levels are required."
                );
            } else {
                currentValidation = currentValidation
                .setIn(["pmTicket", "isValid"], false)
                .setIn(
                    ["pmTicket", "message"],
                    signalLevelErrors ? "Signal level values are invalid." : ""
                );
            }
    }
  }

  return currentValidation;
};



// WEBPACK FOOTER //
// ./src/reducers/work-order/close-step-validation/pmTicketValidator.js